module.exports = __webpack_public_path__ + "img/luthi-4.f6723b9f.jpg";